(function ($) {
    $(window).load(function () {

		/* Burger menu mobile trigger */
		$('#nav-mobile-button').click(function(){
			$('body').toggleClass('no-scroll'); // Disable background scroll when mobile menu is open
			$(this).toggleClass('open');
			$('#navigation-primary').toggleClass('open');
		});

		/* Sub-menu mobile trigger */
		function clickable_submenus() {
			let top_level_link = '#menu-menu-principal .menu-item-has-children > a';
			$(top_level_link).after('<i></i>');
			$(top_level_link).each(function () {
				$(this).next().next('.sub-menu').toggleClass('hide', 1000);
			});
			$(top_level_link + '+ i').on('click', function (event) {
				event.preventDefault();
				$(this).toggleClass('open');
				$(this).next('.sub-menu').toggleClass('hide', 1000);
			});
		}
		setTimeout(function () { clickable_submenus(); }, 300);

		function scrollFunction() {
			if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
				$("header").addClass('scrolled');
			} else {
				$("header").removeClass('scrolled');
			}
		}
		window.onscroll = function() { scrollFunction() };

    });
})(jQuery);
